var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import i18next from "i18next";
import { redirectToPage } from "../../helpers";
import { ERoute } from "../../helpers/Routes";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
import { getSuccessMessagesData, postSuccessAction } from "../../store/actions/response.actions";
import { connect } from "../../store/connect";
import { Button } from "../Form";
import { SuccessPage } from "./SuccessPage";
import { usePresentationComponent } from "../../AppContext";
import omit from "lodash/omit";
import { Flex } from "../Flex";
import styled from "styled-components";
import { Loader } from "../Loader/Loader";
import { getBookManager } from "../../models/BookModel";
/**
 *
 * Success Page
 * Show messages created for the current booking.
 *
 */
var Spinner = styled(Loader)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n position: relative;\n margin-left: 5px;\n &:before {\n     border-width: 1px;\n     width: 15px;\n     height: 15px;\n }\n"], ["\n position: relative;\n margin-left: 5px;\n &:before {\n     border-width: 1px;\n     width: 15px;\n     height: 15px;\n }\n"])));
var ActionButton = /** @class */ (function (_super) {
    __extends(ActionButton, _super);
    function ActionButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function () {
            _this.props.onClick(_this.props.action);
        };
        return _this;
    }
    ActionButton.prototype.renderWithLoading = function () {
        return (React.createElement(Flex, null,
            this.props.label,
            this.props.loading && React.createElement(Spinner, null)));
    };
    ActionButton.prototype.render = function () {
        return React.createElement(Button, { disabled: this.props.disabled, label: this.props.label, onClick: this.handleClick });
    };
    return ActionButton;
}(React.PureComponent));
var SuccessActionButtons = function (_a) {
    var children = _a.children;
    var Renderer = usePresentationComponent("success.buttons") || React.Fragment;
    return React.createElement(Renderer, null, children);
};
var _SuccessPage = /** @class */ (function (_super) {
    __extends(_SuccessPage, _super);
    function _SuccessPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttons = [
            "go_to_booking",
            // "checkin_bookings",
            "new_booking",
        ];
        _this.unmounted = false;
        _this.state = {
            submittedAction: "",
        };
        _this.handleButtonClick = function (action) { return __awaiter(_this, void 0, void 0, function () {
            var _a, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = action;
                        switch (_a) {
                            case "new_booking": return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 2];
                    case 1:
                        redirectToPage("#" + ERoute.BOOKCART);
                        return [2 /*return*/];
                    case 2:
                        this.setState({ submittedAction: action });
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.props.performAction({
                                bookingIds: this.props.bookingIds,
                                action: action,
                            })];
                    case 4:
                        _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _b.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        this.setStateIfMounted({ submittedAction: "" });
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    _SuccessPage.prototype.setStateIfMounted = function (state) {
        if (this.unmounted) {
            return;
        }
        this.setState(state);
    };
    _SuccessPage.prototype.componentWillUnmount = function () {
        this.unmounted = true;
    };
    Object.defineProperty(_SuccessPage.prototype, "bookingIds", {
        get: function () {
            return this.props.bookingIds || [];
        },
        enumerable: false,
        configurable: true
    });
    _SuccessPage.prototype.renderButtons = function () {
        var _this = this;
        if (!this.bookingIds.length) {
            return;
        }
        var actions = {
            go_to_booking: "redirect",
            checkin_bookings: "checkin"
        };
        return this.buttons.map(function (action) {
            var _a;
            var props = {
                action: (_a = actions[action]) !== null && _a !== void 0 ? _a : action,
                key: action,
                onClick: _this.handleButtonClick,
                disabled: !!_this.state.submittedAction,
                loading: action === _this.state.submittedAction,
                label: i18next.t("success_actions." + action, { count: _this.bookingIds.length })
            };
            return React.createElement(ActionButton, __assign({}, props));
        });
    };
    _SuccessPage.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(SuccessPage, __assign({}, omit(this.props, "bookingIds", "performAction")),
                React.createElement(SuccessActionButtons, null, this.renderButtons()))));
    };
    return _SuccessPage;
}(React.PureComponent));
/**
 *
 * Adding props from state
 *
 */
var mapStateToProps = function (state, ownProps) {
    return {
        bookingResponse: getSuccessMessagesData(state.responseReducer).response || null
    };
};
/**
 *
 * Adding dispatchers
 *
 */
var mapDispatchToProps = {
    performAction: postSuccessAction
};
/**
 *
 * fetching outgoing messages from state
 *
 */
var mergedProps = function (_a, dispatch, ownProps) {
    var otherargs = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        otherargs[_i - 3] = arguments[_i];
    }
    var bookingResponse = _a.bookingResponse, props = __rest(_a, ["bookingResponse"]);
    // const outgoingMessageEntities = successMessagesResponse && getResponseManager(successMessagesResponse).outgoingMessages();
    var bookingIds = '';
    try {
        bookingIds = getBookManager(getResponseManager(bookingResponse).entities()).courseParticipants().all().map(function (_a) {
            var id = _a.id;
            return id;
        }).join(",");
    }
    catch (_b) { }
    var mergedProps = __assign(__assign(__assign(__assign(__assign({}, props), dispatch), ownProps), otherargs), { bookingIds: bookingIds });
    return mergedProps;
};
export var AdminSuccessPage = connect(mapStateToProps, mapDispatchToProps, mergedProps)(function (props) {
    var SuccessManager = usePresentationComponent("success.manager") || React.Fragment;
    return (React.createElement(React.Fragment, null,
        React.createElement(SuccessManager, null),
        React.createElement(_SuccessPage, __assign({}, props))));
});
var templateObject_1;
